import React from "react";

const SimpleInput = ({
  label,
  type,
  value,
  onChange,
  required,
  inputType,
  rows,

}) => {
  return (
    <div>
      <label
        htmlFor={label}
        className="block text-sm font-medium leading-6 text-gray-500"
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {inputType === "textarea" ? (
        <textarea
          value={value}
          onChange={onChange}
          rows={rows}
          required={required}
          className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          required={required}
          className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
        />
      )}

    </div>
  );
};

export default SimpleInput;
